// Wraps livekit-client's Room construction with the mode-aware simulcast
// config. Returns the Room instance (not yet connected — caller does
// room.connect(url, token) after wiring listeners). Browser-only — never
// imported from a server-side function.
//
// Mode-driven simulcast: dm publishes 1 layer, grid 2, stage 3. Publishing
// layers nobody subscribes to is pure upload + CPU waste, especially in DMs.
import { Room, VideoPresets } from 'livekit-client'
import { getRoomMode } from './meetUtils.js'

const layersForMode = (mode) => {
  if (mode === 'dm')   return [VideoPresets.h720]
  if (mode === 'grid') return [VideoPresets.h360, VideoPresets.h720]
  return [VideoPresets.h180, VideoPresets.h360, VideoPresets.h720] // stage
}

export const buildLivekitRoom = (initialParticipantCount = 1) => {
  const mode = getRoomMode(initialParticipantCount)
  return new Room({
    adaptiveStream: true,
    dynacast: true,
    videoCaptureDefaults: { resolution: VideoPresets.h720.resolution },
    publishDefaults: {
      simulcast: mode !== 'dm',
      videoSimulcastLayers: layersForMode(mode)
    }
  })
}
